// extracted by mini-css-extract-plugin
export default {"modalBody":"add-member-modal_modalBody__MYOTd"};